import { render, staticRenderFns } from "./mycourses.vue?vue&type=template&id=1151bab0&scoped=true&"
import script from "./mycourses.vue?vue&type=script&lang=js&"
export * from "./mycourses.vue?vue&type=script&lang=js&"
import style0 from "./mycourses.vue?vue&type=style&index=0&id=1151bab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151bab0",
  null
  
)

export default component.exports